import type { GlobalState } from '@/redux/store';

export const getRelatedSearchSuggestions = (state: GlobalState) => state.relatedSearches.suggestions;
